module.exports = __webpack_public_path__ + "static/media/bg-d.e22673be.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-d.webm
// module id = 19
// module chunks = 0